<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3">
            <b-text-field
                :label="translations.subject[lang]"
                no-margin-top
                v-model="messageBody.subject"
            ></b-text-field>

            <b-textarea
                :label="translations.content[lang]"
                v-model="messageBody.content"
            ></b-textarea>

            <div
                style="font-size: 0.875rem"
                class="font-weight-medium mt-8"
            >
                {{ translations.info[lang] }}
                <li class="ml-8">{{ translations.pointsInfo[lang] }} {$points}</li>
                <li class="ml-8">{{ translations.nameInfo[lang] }} {$name}</li>
            </div>

            <v-btn
                :disabled="!getPermission('suppliers.notification_message.update')"
                color="success"
                class="text-capitalize mt-4"
                depressed
                v-text="translations.save[lang]"
                @click="updateMessage(messageBody)"
            ></v-btn>
        </v-sheet>
    </v-container>
</template>

<script>
import { mdiPencilOutline, mdiClose } from "@mdi/js";
import { mapMutations, mapState, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/supplierManagement";

export default {
    name: "SupplierManagement",

    mixins: [translations],

    data: () => ({
        icons: { mdiPencilOutline, mdiClose },
        
    }),

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        messageBody: {
            get() {
                return this.$store.state.loyaltyPanel.supplierManagement.messageBody;
            },
            set(val){
                this.setMessageBody(val)
            }
        },
    },

    methods: {
        ...mapActions(["getPermission"]),
        ...mapActions("loyaltyPanel/supplierManagement", ["getMessage","updateMessage"]),
        ...mapMutations("loyaltyPanel/supplierManagement", ["setMessageBody"])
        
    },

    mounted(){
        this.getMessage()
    }

};
</script>
